import { OpenInNew } from "@mui/icons-material";
import {
  Box,
  Button,
  Fade,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { receiptEndpoint } from "../../../routes/api_endpoints";

/**The final step of the stepper
 * @param {Object} props props
 * @param {boolean} props.receiptImgLoaded Whether the image has finished loading or not, used to display a
 * skeleton as a placeholder
 * @param {Object} props.movieDetails the details of the movie
 * @param {string} props.cinema_name the name of the cinema
 * @param {string} props.showDate the date of the selected show
 * @param {Object} props.show the details of the selected show
 * @param {Object} props.selectedSeats The seats that have been bought
 */
const Receipt = ({
  receiptImgLoaded,
  movieDetails,
  cinema_Name,
  showDate,
  show,
  selectedSeats,
  rContent,
  BookingID,
  phone,
}) => {
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const navigate = useNavigate();
  const Text1 = ({ children }) => {
    return (
      <Typography component="span" fontWeight={300} sx={{ ...spanFontSizes1 }}>
        {children}
      </Typography>
    );
  };
  const Text2 = ({ children }) => {
    return (
      <Typography
        variant={"h5"}
        fontWeight={500}
        fontSize={{
          xs: "1.25rem",
          sm: "2.1rem",
        }}
      >
        {children}
      </Typography>
    );
  };

  return (
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <Typography
        variant="h5"
        sx={{ mx: "auto" }}
        fontSize={{
          xs: "1.25rem",
          sm: "2.1rem",
        }}
      >
        Your purchase was successful
      </Typography>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          border: `1px solid rgb(200,200,200)`,
        }}
      >
        <Stack
          spacing={2}
          direction={{
            xs: "column",
            sm: "row",
          }}
          height={"fit-content"}
        >
          {!receiptImgLoaded.loaded && (
            <Fade in={!receiptImgLoaded.loaded}>
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  borderRadius: "5px",
                  width: {
                    xs: "100%",
                    sm: "15vw",
                  },
                  aspectRatio: "600/950",
                }}
              />
            </Fade>
          )}
          <Fade in={receiptImgLoaded.loaded}>
            <Box
              component="img"
              sx={{
                width: {
                  xs: "50%",
                  sm: "15vw",
                },
                objectFit: "cover",
                border: "1px solid rgb(200,200,200)",
                borderRadius: "5px",
                aspectRatio: "600/950",
              }}
              src={movieDetails.MovieImageSmall}
              alt={"movie_image"}
            ></Box>
          </Fade>

          <Stack spacing={1} justifyContent={"stretch"}>
            <Text2>{movieDetails.MovieName}</Text2>
            <Text1>{cinema_Name}</Text1>
            {/* <Text1>Experience:&nbsp;{experience}</Text1> */}
            <Text1>
              Show:&nbsp;{show.ShowTime}&nbsp;{show.ScreenName}
            </Text1>
            <Text1>Date: {showDate}</Text1>
            <Text1>
              Seats:{" "}
              {Object.values(selectedSeats).map((seat, index) => (
                <span key={seat.TicketCode + seat.SeatNumber}>
                  {seat.SeatNumber},
                </span>
              ))}
            </Text1>
            {BookingID && (
              <Button
                variant="contained"
                sx={{ width: "fit-content" }}
                onClick={() => {
                  window.open(
                    `${receiptEndpoint}/${phone}/${BookingID}`,
                    "_blank"
                  );
                }}
              >
                View ticket&nbsp;
                <OpenInNew />
              </Button>
            )}
            <Button
              variant="outlined"
              sx={{ width: "fit-content" }}
              onClick={() => {
                navigate("/tickets");
              }}
            >
              See all tickets
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
};
export default Receipt;
